export default __webpack_public_path__ + "static/media/breakfast.a8eda5bc.svg";